import styled from 'styled-components';

export const TicketContainer = styled.div`
  height: fit-content;
  width: 296px;
  min-width: 296px;
  max-width: 296px;
  border: 1px solid #CCCCCC;
  background-color: #FAFAFA;
  border-radius: 8px;
  position: relative;
  text-align: left;

  & .event-img {
    width: 100%;
    height: 112px;
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
  }
`;

export const ImageTextContainer = styled.div`
  position: relative;

  & .event-img {
    width: 100%;
    height: 112px;
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
  }
`;

export const TextInsideImage = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  z-index: 999;
  height: 24px;
  background-color: rgba(0, 0, 0, 0.6);
  color: #FFFFFF;
  font-size: 10px;
  font-weight: 500;
  letter-spacing: 0;
  line-height: 16px;
  padding: 4px 8px;
`;

export const EventInfoContainer = styled.div`
  padding: 16px 16px 6px 16px;
  border-bottom: 1px dashed #CCCCCC;
`;

export const TicketOwner = styled.div`
  color: #333333;
  font-size: 20px;
  font-weight: 600;
  letter-spacing: -0.4px;
  line-height: 28px;
  margin-bottom: 4px;
`;

export const EventName = styled.div`
  color: #666666;
  font-size: 14px;
  font-weight: 600;
  letter-spacing: -0.2px;
  line-height: 22px;
  margin-bottom: 16px;
`;

export const EventDataContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
`;

export const EventData = styled.div`
  width: 50%;
  margin-bottom: 16px;
  padding-right: 4px;

  & .title {
    color: #333333;
    font-size: 14px;
    font-weight: 600;
    letter-spacing: -0.2px;
    line-height: 22px;
    margin-bottom: 4px;
  }

  & .subtitle {
    color: #666666;
    font-size: 14px;
    letter-spacing: -0.2px;
    line-height: 22px;
  }
`;

export const TicketQRContainer = styled.div`
  display: flex;
  justify-content: center;
  position: relative;

  & .qr {
    margin-top: 13px;
    margin-bottom: 24px;
    width: 132px;
    height: 132px;
  }

  & .share-icon {
    position: absolute;
    z-index: 999;
    bottom: 12px;
    right: 12px;
  }
`;

export const LeftCircle = styled.div`
  position: absolute;
  width: 18px;
  height: 18px;
  border-right: 1px solid #CCCCCC;
  background-color: white;
  border-radius: 20px;
  bottom: 159px;
  left: -10px;
  z-index: 999;
`;

export const RightCircle = styled.div`
  position: absolute;
  width: 18px;
  height: 18px;
  border-left: 1px solid #CCCCCC;
  background-color: white;
  border-radius: 20px;
  bottom: 159px;
  right: -10px;
  z-index: 999;
`;